import { render, staticRenderFns } from "./ComplexAnswer.vue?vue&type=template&id=05976bc5&scoped=true"
import script from "./ComplexAnswer.ts?vue&type=script&lang=ts&external"
export * from "./ComplexAnswer.ts?vue&type=script&lang=ts&external"
import style0 from "./ComplexAnswer.scss?vue&type=style&index=0&id=05976bc5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05976bc5",
  null
  
)

export default component.exports